<div>
  <div class="row g-3 align-items-center mb-3">
    <div class="filter-wrap">
      <div class="filter-item">
        <label for="zoneSelect" class="col-form-label">Select Group</label>
        <select
          [(ngModel)]="selectedZone"
          id="zoneSelect"
          class="form-select"
          (change)="onZoneChange()"
        >
          <option value="">All</option>
          <option *ngFor="let zone of zoneList" [value]="zone.id">
            {{ zone.name }}
          </option>
        </select>
      </div>
      <form [formGroup]="filterForm" (ngSubmit)="filter()">
        <div class="filter-item">
          <label for="fromDate" class="col-form-label">From</label>
          <input
            type="text"
            class="form-control"
            placeholder="Select a date"
            id="fromDate"
            bsDatepicker
            [bsConfig]="datePickerConfig"
            [maxDate]="maxDate"
            [minDate]="minDate"
            formControlName="fromDate"
          />
        </div>

        <div class="filter-item">
          <label for="tillDate" class="col-form-label">To</label>
          <input
            type="text"
            class="form-control"
            placeholder="Select a date"
            id="tillDate"
            bsDatepicker
            [bsConfig]="datePickerConfig"
            [minDate]="tillDateMinDate"
            [maxDate]="maxDate"
            formControlName="tillDate"
          />
        </div>

        <div class="filter-item">
          <button type="submit" class="btn btn-primary-sa btn-sm float-start">
            Search
          </button>
        </div>
      </form>
      <button
        href="javascript:void(0)"
        (click)="clearFilter()"
        class="btn btn-primary-sa btn-sm mb-2 me-2 float-start"
      >
        Clear
      </button>
      <button
        (click)="exportWateruses()"
        href="javascript:void(0)"
        class="btn btn-primary-sa btn-sm mb-2 me-2 float-start"
      >
        Export
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-3 col-md-6 mb-3">
      <div class="card shadow-sm">
        <div class="card-body py-3 px-2">
          <div class="ft-varient1-text">
            <p class="mb-1">Water Consumption Details</p>
            <p class="font-10p m-0">Last capture date</p>
          </div>
        </div>
        <div class="card-footer ft-varient5">
          <h6 class="ng-star-inserted">
            <span *ngIf="lastDevicecapturedTime; else fallback">
              {{ lastDevicecapturedTime | date : "dd-MM-yyyy" }}
            </span>
            <ng-template #fallback>--/--/----</ng-template>
          </h6>
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-md-6 mb-3">
      <div class="card shadow-sm">
        <div class="card-body p-3">
          <div class="ft-varient2-text">
            <h6 class="line-h-32p m-0">Domestic</h6>
          </div>
        </div>
        <div class="card-footer ft-varient6">
          <h6>
            {{ convertAndRound(domesticConsumption) }}
            <span class="font-10p">Cubic Meter</span>
          </h6>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 mb-3">
      <div class="card shadow-sm">
        <div class="card-body p-3">
          <div class="ft-varient3-text">
            <h6 class="line-h-32p m-0">Commercial</h6>
          </div>
        </div>
        <div class="card-footer ft-varient5">
          <h6>
            {{ convertAndRound(commercialConsumption) }}
            <span class="font-10p">Cubic Meter</span>
          </h6>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 mb-3">
      <div class="card shadow-sm">
        <div class="card-body p-3">
          <div class="ft-varient4-text">
            <h6 class="line-h-32p m-0">NRW</h6>
          </div>
        </div>
        <div class="card-footer ft-varient6">
          <h6>
            {{ convertAndRound(nRWConsumption) }}
            <span class="font-10p">Cubic Meter</span>
          </h6>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-9 mb-3">
      <div class="card p-3">
        <p>Device Locations</p>
        <div class="text-center">
          <div class="map-container">
            <div class="map-frame">
              <!-- Google Maps requires the map div to have explicit width and height -->
              <div id="deviceMap" style="width: 100%; height: 500px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 mb-3">
      <div class="row">
        <div class="col-md-12 mb-3">
          <div class="card shadow-sm">
            <div class="card-body p-3">
              <h6 class="text-center">Meter Installed</h6>
            </div>
            <div class="card-footer ft-varient5 fw-bold">
              <strong>{{ meterCount }}</strong>
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div
            class="card shadow-sm p-2"
            style="display: flex; justify-content: center; align-items: center"
          >
            <div
              style="
                width: 100%;
                max-width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
              "
            >
              <apx-chart
                *ngIf="chartOptions"
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [labels]="chartOptions.labels"
                [title]="chartOptions.title"
                [responsive]="chartOptions.responsive"
                [plotOptions]="chartOptions.plotOptions"
                [colors]="chartOptions.colors"
                [legend]="chartOptions.legend"
                [dataLabels]="chartOptions.dataLabels"
                [noData]="chartOptions.noData"
              ></apx-chart>
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="card shadow-sm">
            <div class="card-body p-3 text-center">
              <h6 class="text-orange">Data Management</h6>
              <p class="text-center m-0 text-orange">
                Reporting Interval :
                {{ dataMangementWidgetData?.reporting_interval }}
              </p>
            </div>
            <div class="card-footer bg-black border-top-white text-center">
              <p class="m-0 pb-1 font-10p text-white">Last Status Update</p>
              <p class="m-0 font-10p text-white">
                <span
                  *ngIf="
                    dataMangementWidgetData?.last_data_reporting_time;
                    else fallback1
                  "
                >
                  {{
                    dataMangementWidgetData?.last_data_reporting_time
                      | date : "dd-MM-yyyy HH:mm:ss"
                  }}
                </span>
                <ng-template #fallback1>--/--/----</ng-template>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
